import { render } from "./PanelClienteActividad.vue?vue&type=template&id=dfffc446&scoped=true"
import script from "./PanelClienteActividad.vue?vue&type=script&lang=js"
export * from "./PanelClienteActividad.vue?vue&type=script&lang=js"

import "./PanelClienteActividad.vue?vue&type=style&index=0&id=dfffc446&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfffc446"]])

export default __exports__